import React from 'react'
import styled from '@emotion/styled'

import Placeloader from '../Placeloader'

const getIntFromPx = (px: string) => parseInt(px.replace(/[^0-9]/g, ''), 10)

const calcTextPadding = (lineHeight: string, fontSize: string) =>
  `${(getIntFromPx(lineHeight) - getIntFromPx(fontSize)) / 2}px`

type ContainerProps = {
  width: string | number
}

const Container = styled.div<ContainerProps>((props) => ({
  width: props.width,
}))

type TextContainerProps = {
  paddingTop: string
  paddingBottom: string
}

const TextContainer = styled.div<TextContainerProps>((props) => ({
  paddingTop: props.paddingTop,
  paddingBottom: props.paddingBottom,
}))

type TextPlaceloaderProps = {
  fontSize: string
}

const TextPlaceloaderComponent = styled(Placeloader)<TextPlaceloaderProps>((props) => ({
  height: props.fontSize,
}))

export interface Props extends React.ComponentPropsWithoutRef<'div'> {
  /** Sets the width of the loader. */
  w?: string | number
  /** Sets the font size of the text. */
  fs?: string
  /** Sets the padding top of the text. */
  pt?: string
  /** Sets the padding bottom of the text. */
  pb?: string
  /** Sets the line height of the text. */
  lh?: string
}

const TextPlaceloader = ({ w = '100%', pt, pb, lh = '20px', fs = '16px', ...others }: Props) => {
  const paddingTopVal = pt || calcTextPadding(lh, fs)
  const paddingBottomVal = pb || calcTextPadding(lh, fs)

  return (
    <Container width={w} {...others} data-testid="text-outer-container">
      <TextContainer
        data-testid="text-inner-container"
        paddingTop={paddingTopVal}
        paddingBottom={paddingBottomVal}
      >
        <TextPlaceloaderComponent data-testid="text-placeholder" fontSize={fs} />
      </TextContainer>
    </Container>
  )
}

export default TextPlaceloader
